import React from 'react';
import { compose, Query, QueryResult } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { DocumentNode } from 'graphql';
import InputSelect from './InputSelect';

interface Props {
    name: string;
    value: string | number | null;
    query: DocumentNode;
    variables?: any;
    queryCallback: (result: QueryResult<any, any>) => Array<{id: string | number, label: string}>;
    placeholder?: string;
    hint?: string;
    empty?: string;
    isClearable?: boolean;
    onChangeHandler: (value: string | number | null, name: string) => void;

}

interface State {
    value: string | number | null;
}

class InputQuerySelect<T> extends React.Component<Props & InjectedIntlProps, State> {

    public state = {
        value: null,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <Query query={this.props.query} variables={this.props.variables}>
                {(result) => {
                    if (result.loading) return null;
                    if (result.error) return `Error!: ${result.error}`;

                    if (result.data) {
                        const options = this.props.queryCallback(result);
                        const { query, variables, queryCallback, ...otherProps } = this.props;
                        return (
                            <InputSelect {...otherProps} options={options} />
                        );
                    }
                    return null;
                }}
            </Query>
        );
    }
}

export default compose(
    injectIntl,
)(InputQuerySelect);



// WEBPACK FOOTER //
// ./src/components/Form/InputQuerySelect.tsx